import { Box, Menu } from '@mantine/core';
import logoUrl from '../../assets/icons/tripleNet.svg';
import Button from '../../utils/Button/index';
import { useStyles } from './style';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import user from '../../assets/images/user.png';
import unreadnotification from '../../assets/icons/UnreadNotification.svg';
import readnotifications from '../../assets/icons/notifications.svg';
import hamburger from '../../assets/icons/hamburger.svg';
import cross from '../../assets/icons/cross.svg';
import { useEffect, useRef, useState } from 'react';
import { getLinks, properties } from './properties';
import { Outlet } from 'react-router-dom';
import {
  getUserType,
  clearUserData,
  getUserData,
  getHeader,
  doRedirectIfUnAuth
} from '../../config/userSession';
import InvitePopup from './invitePopup';
import Notifications from './notifications';
import { baseURL } from '../../config/urls';
import { useQuickstartContext } from '../../context';
import { SupportModal } from './support-modal';
import { Sidebar } from '../../pages/common/SideBar';
import LanguageSwitcher from './language';
import GoogleTranslate from './language';
import { useActivityTracker } from '../../hooks/useActivityTracker';

const Header = ({}) => {
  const bodyRef = useRef(null);
  const userType = getUserType();
  const { classes, theme } = useStyles(useStyles);
  const [mobileNavOpened, setMobileNavOpened] = useState(false);
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const [notificationsOpened, setNotificationsOpened] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [userProfileImage, setUserProfileImage] = useState('');
  const [userProfileImageKey, setUserProfileImageKey] = useState();
  const [supportModalOpened, setSupportModalOpened] = useState(false);
  const { trackEvent } = useActivityTracker();
  const userDetails = getUserData();

  const handleOpenSupport = () => {
    setSupportModalOpened(true);
  };
  const navigate = useNavigate();
  const openMobileNavHandler = (boolean) => {
    setMobileNavOpened(boolean);
  };
  const doLogout = async () => {
    await trackEvent('logout-success', {
      userType,
      userEmail: userDetails.email,
      message: 'logged out successfully'
    });
    setTimeout(() => {
      clearUserData();
      window.location.reload();
    }, 1000);
  };
  const { state, profilePictureUrl } = useQuickstartContext();

  const { titles, notifications } = properties;

  const notificaitionUnread =
    notifications.filter((notificatoin) => notificatoin.status === 'unread')
      .length > 0;
  const searchProfile = () => {
    if (
      userDetails?.imageUrlKey !== null &&
      userDetails?.imageUrlKey !== undefined &&
      userDetails?.imageUrlKey !== ''
    ) {
      setIsProfile(true);
    } else {
      setIsProfile(false);
    }
  };

  useEffect(() => {
    searchProfile();
  }, [userDetails]);

  useEffect(() => {
    setUserProfileImageKey(userDetails?.imageUrlKey);
  }, [userDetails?.imageUrlKey]);

  async function fetchProfileImage() {
    const response = await fetch(
      `${baseURL}/account/profile-image/${userProfileImageKey}`,
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    if (response.ok) {
      const res = await response.json();
      setUserProfileImage(res.imageUrl);
    } else {
      // setLoading(false);
      doRedirectIfUnAuth(response.status);
    }
  }

  useEffect(() => {
    if (userProfileImageKey) fetchProfileImage();
  }, [userDetails, userProfileImageKey]);

  const handleOpenProfilePage = () => {
    navigate(`/${userType.toLowerCase()}/profile`);
    openMobileNavHandler(false);
  };
  const handleOpenSupportPage = () => {
    navigate(`/${userType.toLowerCase()}/support-requests`);
    openMobileNavHandler(false);
  };

  document.querySelector('body').style.overflowY = mobileNavOpened
    ? 'hidden'
    : 'scroll';
  return (
    <>
      <SupportModal
        email={userDetails?.email}
        opened={supportModalOpened}
        onClose={() => setSupportModalOpened(false)}
      />

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div>
          <Sidebar />
        </div>
        <div style={{ width: '100%' }}>
          <Box className={classes.wrapperContainer}>
            <Box className={classes.wrapper}>
              <p> </p>

              <Box className={classes.linksAndUser}>
                {userType === properties.userType.landlord ||
                userType === properties.userType.tenant ||
                userType === properties.userType.manager ? null : (
                  <InvitePopup />
                )}
                <GoogleTranslate />
                <Notifications
                  onClose={() => setNotificationsOpened(false)}
                  opened={notificationsOpened}
                />
                <Menu>
                  <img
                    onClick={() => setNotificationsOpened(true)}
                    className={classes.mobileNotification}
                    src={
                      notificaitionUnread
                        ? readnotifications
                        : unreadnotification
                    }
                    alt="hamburger"
                  />
                  <Menu.Target>
                    <Box className={classes.menuTarget}>
                      {!isProfile ? (
                        <span className={classes.demoProfile}>
                          {userDetails?.firstName?.charAt(0).toUpperCase() +
                            userDetails?.lastName?.charAt(0).toUpperCase()}
                        </span>
                      ) : (
                        <span className={classes.demoProfile}>
                          <img
                            className={classes.demoProfile}
                            src={userProfileImage}
                            alt="user"
                          />
                        </span>
                      )}

                      <BiChevronDown />
                    </Box>
                  </Menu.Target>
                  <Menu.Dropdown className={classes.dropdown}>
                    <Menu.Item
                      onClick={handleOpenProfilePage}
                      className={classes.menuItem}
                    >
                      {titles.myProfile}
                    </Menu.Item>
                    <Menu.Item
                      onClick={handleOpenSupportPage}
                      className={classes.menuItem}
                    >
                      {titles.support}
                    </Menu.Item>
                    <Menu.Item className={classes.menuItem} onClick={doLogout}>
                      {titles.logout}
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Box>
              {/* for mobile */}
              <Box className={classes.mobileNotificationAndHamburger}>
                <img
                  onClick={() => setNotificationsOpened(true)}
                  className={classes.mobileNotification}
                  src={
                    notificaitionUnread ? readnotifications : unreadnotification
                  }
                  alt="hamburger"
                />
                <Box className={classes.hamburgerContainer}>
                  <img
                    onClick={openMobileNavHandler}
                    className={classes.hamburger}
                    src={hamburger}
                    alt="hamburger"
                  />
                </Box>
              </Box>
              <Box
                className={`${classes.openedMobileNav} ${
                  mobileNavOpened && classes.openTheNav
                }`}
              >
                <img
                  onClick={() => openMobileNavHandler(false)}
                  className={classes.crossIcon}
                  src={cross}
                  alt="notifications"
                />

                <Box
                  className={`${classes.dropdownContainer} ${
                    dropdownOpened && classes.dropdownContainerOpened
                  }`}
                >
                  <Box
                    onClick={() => setDropdownOpened(!dropdownOpened)}
                    className={`${classes.menuTargetMobile}`}
                  >
                    <Box className={classes.imageAndUsername}>
                      {!isProfile ? (
                        <img
                          className={classes.demoUser}
                          src={user}
                          alt={'user'}
                        />
                      ) : (
                        <span className={classes.demoProfile}>
                          {userDetails?.firstName?.charAt(0).toUpperCase() +
                            userDetails.lastName?.charAt(0).toUpperCase()}
                        </span>
                      )}
                      <p className={classes.userName}>
                        {userDetails?.firstName + ' ' + userDetails?.lastName}
                      </p>
                    </Box>
                    {dropdownOpened ? (
                      <BiChevronUp className={classes.downArrow} />
                    ) : (
                      <BiChevronDown className={classes.downArrow} />
                    )}
                  </Box>
                  <Box className={classes.menuItems}>
                    <Box
                      onClick={handleOpenProfilePage}
                      className={classes.menuItem}
                    >
                      {titles.myProfile}
                    </Box>
                    <Box
                      onClick={handleOpenSupportPage}
                      className={classes.menuItem}
                    >
                      {titles.support}
                    </Box>
                    <Box onClick={doLogout} className={classes.menuItem}>
                      {titles.logout}
                    </Box>
                  </Box>
                </Box>

                <Box className={classes.mobileLinks}>
                  <NavLink
                    onClick={() => setMobileNavOpened(false)}
                    className={({ isActive, isPending }) =>
                      isActive ? classes.activeMobileLink : classes.mobileLink
                    }
                    to={'/assistant'}
                  >
                    AI Chatbot
                  </NavLink>
                  <NavLink
                    onClick={() => setMobileNavOpened(false)}
                    className={({ isActive, isPending }) =>
                      isActive ? classes.activeMobileLink : classes.mobileLink
                    }
                    to={'/documents'}
                  >
                    IDP
                  </NavLink>
                  {getLinks(userType)?.map((element) => {
                    return (
                      <NavLink
                        key={element.title}
                        onClick={() => setMobileNavOpened(false)}
                        className={({ isActive, isPending }) =>
                          isActive
                            ? classes.activeMobileLink
                            : classes.mobileLink
                        }
                        to={element.link}
                      >
                        {element.title}
                      </NavLink>
                    );
                  })}
                </Box>
                {userType === properties.userType.landlord ||
                userType === properties.userType.tenant ||
                userType === properties.userType.manager ? null : (
                  <InvitePopup />
                )}
              </Box>
            </Box>

            <Notifications
              onClose={() => setNotificationsOpened(false)}
              opened={notificationsOpened}
            />
          </Box>
          <div
            style={{
              height: '80vh', // Adjust based on your header
              overflowY: 'auto',
              margin: 0,
              padding: 0,
              background: 'rgba(224,244,245,0.5)'
            }}
          >
            <div style={{ margin: 0, padding: 0 }}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
